import { render, staticRenderFns } from "./ListRoute.vue?vue&type=template&id=87945ac4&scoped=true&"
import script from "./ListRoute.vue?vue&type=script&lang=js&"
export * from "./ListRoute.vue?vue&type=script&lang=js&"
import style0 from "./ListRoute.vue?vue&type=style&index=0&id=87945ac4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87945ac4",
  null
  
)

export default component.exports